/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './application_flow';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "PreviewApplicationFlow": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.sfs.external.models.ApplicationFlow.Status",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.PreviewApplicationFlow) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Limited application flow info
 * --
 *
 * SOURCE PreviewApplicationFlow @ squareup/sfs/external/models/preview_application_flow.proto at 11:1
 */
export const PreviewApplicationFlow = $root.lookupType('squareup.sfs.external.models.PreviewApplicationFlow');
fixType(PreviewApplicationFlow, {
  id: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(PreviewApplicationFlow);